import {Outlet} from 'react-router';
import {tr} from '../i18n/idioma';
import {usePermisos} from './sesion-contexto';

// Las secciones de administracion: si el rol no lo permite, un aviso en vez
// de la pantalla (la API lo rechaza igual).
export function SoloAdministrador() {
  const permisos = usePermisos();
  if (!permisos.administrar) {
    return (
      <section className="max-w-2xl rounded-lg border border-dorado/50 bg-dorado-claro p-4 text-sm">
        <div className="font-medium">
          {tr('Solo un administrador puede ver esta sección.', 'Only an administrator can see this section.')}
        </div>
        <div className="mt-1 text-apagado">
          {tr(
            'Si necesitas un cambio de usuarios o de configuración, pídeselo a un administrador.',
            'If you need a change to users or settings, ask an administrator.',
          )}
        </div>
      </section>
    );
  }
  return <Outlet />;
}
